module.exports = __webpack_public_path__ + "static/media/storm.62d1b8e2.png";